/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, lockedBy: NonNullable<unknown> }} Explorer_Display_Delete_Skipped_Locked_ToastInputs */



/**
* | output |
* | --- |
* | "Skipped \"{name}\" as it's locked by {lockedBy}" |
*
* @param {Explorer_Display_Delete_Skipped_Locked_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_delete_skipped_locked_toast = /** @type {((inputs: Explorer_Display_Delete_Skipped_Locked_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Delete_Skipped_Locked_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`"${i?.name}" ignore car il est verrouille par ${i?.lockedBy}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`"${i?.name}" wurde übersprungen, da es von ${i?.lockedBy} gesperrt ist.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Saltato "${i?.name}" perché bloccato da ${i?.lockedBy}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Пропущен "${i?.name}", так как он заблокирован ${i?.lockedBy}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se omitió "${i?.name}" porque está bloqueado por ${i?.lockedBy}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已跳过“${i?.name}”，因为它已被“${i?.lockedBy}”锁定。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`「${i?.name}」は${i?.lockedBy}によってロックされているためスキップされました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`"${i?.name}" को छोड़ दिया गया है क्योंकि यह ${i?.lockedBy} द्वारा लॉक किया गया है।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`"${i?.name}" foi ignorado porque está bloqueado por ${i?.lockedBy}`)
	return /** @type {LocalizedString} */ (`Skipped "${i?.name}" as it's locked by ${i?.lockedBy}`)
});